import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ecfc6e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfc6e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecfc6e4')) {
      api.createRecord('2ecfc6e4', component.options)
    } else {
      api.reload('2ecfc6e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ecfc6e4&scoped=true", function () {
      api.rerender('2ecfc6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/check_info_modal/index.vue"
export default component.exports